export default "__VITE_ASSET__DcuY_RmV__"